module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens27-680ef22c6c0eb72ff7822e2f004b9b1c.jpg";